// extracted by mini-css-extract-plugin
export default {"settings":"BrandGroupLogo_settings__5Onx6","imageBox":"BrandGroupLogo_imageBox__3jZL0","footer":"BrandGroupLogo_footer__JqKWF"};